import {
  GET_PERFORMANCEPREDICATE,
  GET_PERFORMANCEPREDICATE_SUCCESS,
  GET_PERFORMANCEPREDICATE_FAIL,
  DELETE_PERFORMANCEPREDICATE,
  DELETE_PERFORMANCEPREDICATE_SUCCESS,
  DELETE_PERFORMANCEPREDICATE_FAIL,
  UPDATE_PERFORMANCEPREDICATE,
  UPDATE_PERFORMANCEPREDICATE_SUCCESS,
  UPDATE_PERFORMANCEPREDICATE_FAIL,
  ADD_NEW_PERFORMANCEPREDICATE,
  ADD_PERFORMANCEPREDICATE_SUCCESS,
  ADD_PERFORMANCEPREDICATE_FAIL,
  PERFORMANCEPREDICATE_LOADING,
  PERFORMANCEPREDICATE_RESET,
} from "./actionType";

export const resetPerformancePredicateState = (actionType) => ({
  type: PERFORMANCEPREDICATE_RESET,
  payload: { actionType },
});

export const getPerformancePredicateSuccess = (actionType, data) => ({
  type: GET_PERFORMANCEPREDICATE_SUCCESS,
  payload: { actionType, data },
});

export const getPerformancePredicateFail = (actionType, error) => ({
  type: GET_PERFORMANCEPREDICATE_FAIL,
  payload: { actionType, error },
});

export const getPerformancePredicate = data => ({
  type: GET_PERFORMANCEPREDICATE,
  payload: data,
});

export const getPerformancePredicateLoading = () => ({
  type: PERFORMANCEPREDICATE_LOADING
});

export const deletePerformancePredicate = data => ({
  type: DELETE_PERFORMANCEPREDICATE,
  payload: data,
});

export const deletePerformancePredicateSuccess = data => ({
  type: DELETE_PERFORMANCEPREDICATE_SUCCESS,
  payload: data,
});

export const deletePerformancePredicateFail = error => ({
  type: DELETE_PERFORMANCEPREDICATE_FAIL,
  payload: error,
});

export const updatePerformancePredicate = data => ({
  type: UPDATE_PERFORMANCEPREDICATE,
  payload: data,
});

export const updatePerformancePredicateFail = error => ({
  type: UPDATE_PERFORMANCEPREDICATE_FAIL,
  payload: error,
});

export const updatePerformancePredicateSuccess = data => ({
  type: UPDATE_PERFORMANCEPREDICATE_SUCCESS,
  payload: data,
});

export const addNewPerformancePredicate = data => ({
  type: ADD_NEW_PERFORMANCEPREDICATE,
  payload: data,
});

export const addPerformancePredicateSuccess = data => ({
  type: ADD_PERFORMANCEPREDICATE_SUCCESS,
  payload: data,
});

export const addPerformancePredicateFail = error => ({
  type: ADD_PERFORMANCEPREDICATE_FAIL,
  payload: error,
});